module.exports = __webpack_public_path__ + "assets/amazon-cloudfront.c8746a45.svg";